export function getWindow() {
  return globalThis as any as Window;
}
